import Cookie from 'js-cookie';

const TOKEN_NAME = process.env.VUE_APP_COOKIE_TOKEN_NAME;
const JOB_FILTER = '_C1_Job_Filter_Url';
const OAUTH_INFO = '_C1_Oauth_Info';
const LOCALE_WPML = 'wp-wpml_current_language';

export default {
    setToken(token) {
        Cookie.set(TOKEN_NAME, token, { expires: 30 });
        try {
            window.userLoggedInEvnt();
        } catch (e) {
            console.log(e);
        }
    },

    getToken() {
        return Cookie.get(TOKEN_NAME);
    },

    deleteToken() {
        Cookie.remove(TOKEN_NAME);
    },

    setJobFilter(filter) {
        Cookie.set(JOB_FILTER, filter);
    },

    getJobFilter() {
        return Cookie.get(JOB_FILTER);
    },

    deleteJobFilter() {
        Cookie.remove(JOB_FILTER);
    },

    setOauthInfo(data) {
        Cookie.set(OAUTH_INFO, data);
    },

    getOauthInfo() {
        return Cookie.get(OAUTH_INFO);
    },

    deleteOauthInfo() {
        Cookie.remove(OAUTH_INFO);
    },

    getWpmlLocale() {
        const loc = Cookie.get(LOCALE_WPML);
        return loc === 'en' || '' ? '' : loc;
    },
};
